import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import * as React from 'react'

export function ActivityFormHeader() {
  return (
    <Stack>
      <Typography variant="h6">Edit Activity</Typography>
    </Stack>
  )
}
